export type InvoiceStatsAttributes = {
    draftCount: number
    draftAmount: string
    partiallyPaidCount: number
    partiallyPaidAmount: string
    sentCount: number
    sentAmount: string
}

export type InvoiceStatsDto = {
    id: string
    type: string
    attributes: InvoiceStatsAttributes
}

export default class InvoiceStats {
    private dto: InvoiceStatsDto

    constructor(dto: InvoiceStatsDto) {
        this.dto = dto
    }

    isLoaded(): boolean {
        return this.getId() != "" && this.dto.type == "invoice-stats"
    }

    getId(): string {
        return this.dto.id
    }

    getAttributes(): InvoiceStatsAttributes {
        return this.dto.attributes
    }
}


// WEBPACK FOOTER //
// ./src/state/stats/InvoiceStats.ts